import React, { useEffect } from 'react';
import { WithWizard } from 'react-albus-react18';
import CustomTitle from '../../components/UI/title/CustomTitle';
import BeforeAfterComponent from '../../components/BeforeAfter/BeforeAfterComponent';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import useMixpanel from '../../hooks/useMixpanel';
import BeforeAfterContent from './BeforeAfterContent';
import PageContent from '../../components/PageContent/PageContent';

const BeforeAfter = ({ id }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));

        dispatch(setIsShowButtonNot(false));
    }, []);
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const { trackP1Event } = useMixpanel();
    const eventNames = ['onboarding_video_reason', 'onboarding_static_reason', 'onboarding_ad_reason'];
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            trackP1Event(eventNames[id], {})
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    const titles = [
        "AI-driven video ads surpass manual ones with quicker creation and better results",
        "Static AI ads outperform manual ones with deep insights and quick creation",
        "AI-powered ads outshine manual ones with the advantage of big data",
    ]

    return (
        <div className="page" >
            <PageContent>
                <div className="page-content">
                    <CustomTitle style={{ marginBottom: id != '0' ? "12rem" : "20rem" }} title={titles[id]} />
                    {
                        id === '1' && <p className="text" style={{ marginBottom: "24rem" }}>*Based on our users' increased sales results</p>
                    }
                    {
                        id === '2' && <p className="text" style={{ marginBottom: "24rem" }}>* Based on the increased sales results of our users</p>
                    }


                    <BeforeAfterContent id={id} />
                </div>
            </PageContent>
        </div>



    );
}

export default BeforeAfter;
